import {
  AppBar,
  Box,
  Button,
  Chip,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Link,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import GoBackButton from "../components/GoBackButton";
import Layout from "../layouts/Layout";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import TableHeadCell from "../components/TableHeadCell";
import DeviceStatus from "../components/DeviceStatus";
import RefreshButton from "../components/RefreshButton";
import PortStatus from "../components/PortStatus";
import AddLabel from "../components/AddLabel";
import {
  getEmail,
  getName,
  hasNetworkingAccess,
  hasPlanChangeAccess,
  isSuperAdmin,
  hasSimActivityAccess,
  hasUptimeAccess,
} from "../../src/auth/roles";
import ChangePortGroup from "../components/ChangePortGroup";
import SpeedTest from "../components/SpeedTest";
import { TabContext, TabPanel } from "@material-ui/lab";
import Alert from "@material-ui/lab/Alert";
import SpeedTestHistory from "../components/SpeedTestHistory";
import {
  BLUE,
  SPEED_TEST_TYPES,
  simActivityStatusMap,
} from "../utils/constants";
import NetScanHistory from "../components/NetScanHistory";
import PermScanWifiIcon from "@material-ui/icons/PermScanWifi";
import NetDiagResult from "../components/NetDiagResult";
import StartNetDiag from "../components/StartNetDiag";
import { GREEN, RED, YELLOW } from "../utils/constants";
import ChangeDevicePlan from "../components/ChangeDevicePlan";
import PassStatus from "../components/PassStatus";
import moment from "moment";
import queryString from "query-string";
import { getTheme, isSemsimBasicUser, showSupportButton } from "../partners/utils";
import { Close, HelpOutline, Settings } from "@material-ui/icons";

import UpdateDeviceFW from "../components/UpdateDeviceFW";
import DeviceSsidModal from "./DeviceSsidModal";
import RestartDevice from "../components/RestartDevice";
import DeviceRestartScheduleModal from "./DeviceRestartScheduleModal";
import NightsStayIcon from "@material-ui/icons/NightsStay";
import DeviceNetwork from "../components/DeviceNetwork";
import DeviceConfiguration from "../components/DeviceConfiguration";
import SignalStrength from "../components/SignalStrength";
import AntennaSignalStrength from "../components/AntennaStrength";
import { splitSignal } from "../utils/signalParser";
import SimActivityLog from "../components/SimActivityLog";
import { checkDeviceInfo } from "../utils/string";
import Map from "../components/Map";
import ServingCellHistory from "../components/ServingCellHistory";
import ConnectedDevices from "../components/ConnectedDevices";
import DeviceMonthlyUsageHistory from "../components/DeviceMonthlyUsageHistory";
import DeviceActionHistory from "../components/DeviceActionHistory";
import DeviceMonitor from "../components/DeviceMonitor";
import UptimePingDevice from "../components/UptimePingDevice";
import DeviceSearch from "../components/DeviceSearch";

const styles = {
  chatWidget: {
    // Position
    position: "fixed",
    bottom: "5px",
    right: "5px",
  },
  formContainer: {
    // Position
    position: "fixed",
    bottom: "15px",
    right: "20px",
    zIndex: "50000",
  },
  chatWidgetBtn: {
    color: "white",
    fontSize: "15px",
    textTransform: "capitalize",
    backgroundColor: getTheme().palette.primary.main,
    // Padding
    paddingLeft: "18px",
    paddingRight: "18px",
    paddingTop: "7px",
    paddingBottom: "7px",
    // Border
    borderRadius: "50px",
    cursor: "pointer",
  },
};

const DeviceInfoSignal = (props) => {
  const { formtest } = queryString.parse(props.location.search);
  const history = useHistory();
  const { device_uuid } = useParams();
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [deviceLoading, setDeviceLoading] = useState(false);
  const [m1Loading, setM1Loading] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState(undefined);
  const [cellInfo, setCellInfo] = useState(undefined);
  const [m1Info, setM1Info] = useState(undefined);
  const [deviceDBInfo, setDeviceDBInfo] = useState(undefined);
  const [portInfo, setPortInfo] = useState(undefined);
  const [simActivity, setSimActivity] = useState(undefined);
  const [connectedDevices, setConnectedDevices] = useState(null);
  const [latestSpeedTestResult, setLatestSpeedTestResult] = useState(undefined);
  const [latestNetScanResult, setLatestNetScanResult] = useState(undefined);
  const [tabValue, setTabValue] = useState("Info");
  const [message, setMessage] = useState(undefined);
  const [ssidModal, setSsidModal] = useState(false);
  const [confirmConfigDialog, setConfirmConfigDialog] = useState(false);
  const [coordinates, setCoordinates] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [addNoteOpen, setAddNoteOpen] = useState(false);
  const [newNoteText, setNewNoteText] = useState("");
  const [addNoteSubmitting, setAddNoteSubmitting] = useState(false);
  const [mtuDialogOpen, setMtuDialogOpen] = useState(false);
  const [mtuValue, setMtuValue] = useState("");
  const [mtuLoading, setMtuLoading] = useState(false);
  const [mtuSubmitting, setMtuSubmitting] = useState(false);
  const [mtuError, setMtuError] = useState("");
  const [lanIpDialogOpen, setLanIpDialogOpen] = useState(false);
  const [lanIpValue, setLanIpValue] = useState("");
  const [lanIpLoading, setLanIpLoading] = useState(false);
  const [lanIpSubmitting, setLanIpSubmitting] = useState(false);
  const [lanIpError, setLanIpError] = useState("");

  useEffect(() => {
    if (!deviceInfo) return;

    let arr = JSON.parse(localStorage.getItem("recentDevices")) || [];

    // Filter out any existing object with the same device_uuid
    arr = arr.filter((item) => item.uuid !== device_uuid);

    // Add the new deviceInfo object to the front
    arr.unshift({ ...deviceInfo, uuid: device_uuid });

    // Limit array to max 10 elements
    if (arr.length > 10) {
      arr = arr.slice(0, 10);
    }

    // Save updated array back to localStorage
    localStorage.setItem("recentDevices", JSON.stringify(arr));
  }, [deviceInfo]);

  const [isHelpFormOpen, setIsHelpFormOpen] = useState(false);
  const getDeviceInfo = () => {
    setLoading(true);
    axios
      .get(`/device/${device_uuid}/info`)
      .then((response) => {
        setDeviceInfo(response.data.device);
        setPortInfo(response.data.port);
        setDeviceDBInfo(response.data.db_info);
        setCellInfo(response.data.cell_info);
        setLatestSpeedTestResult(response.data.latest_speed_test_result);
        setLatestNetScanResult(response.data.latest_net_scan_result);
      })
      .catch((error) => {
        setError(error?.response?.data?.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getM1Info = () => {
    setM1Loading(true);
    axios
      .get(`/device/${device_uuid}/m1_info`)
      .then((response) => {
        setM1Info(response.data);
      })
      .catch((error) => {
        setError(error?.response?.data?.detail);
      })
      .finally(() => {
        setM1Loading(false);
      });
  };

  const getNotes = () => {
    setNotesLoading(true);
    axios
      .get(`/device/${device_uuid}/notes`)
      .then((response) => {
        setNotes(Array.isArray(response?.data) ? response.data : []);
      })
      .catch((error) => {
        setError(error?.response?.data?.detail);
      })
      .finally(() => setNotesLoading(false));
  };

  const createNote = () => {
    if (!newNoteText?.trim()) return;
    setAddNoteSubmitting(true);
    axios
      .post(`/device/${device_uuid}/notes`, { notes: newNoteText.trim() })
      .then((response) => {
        setMessage("Note added successfully");
        setAddNoteOpen(false);
        setNewNoteText("");
        getNotes();
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Failed to add note");
      })
      .finally(() => setAddNoteSubmitting(false));
  };

  const fetchMtu = () => {
    setMtuLoading(true);
    setMtuError("");
    axios
      .get(`/device/${device_uuid}/mtu`)
      .then((response) => {
        // Handle different possible response formats
        const mtu = response.data?.mtu ?? response.data?.value ?? response.data ?? "";
        setMtuValue(mtu.toString());
        setMtuError("");
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.detail || error?.response?.data?.message || error?.message || "Failed to fetch MTU";
        setMtuError(errorMessage);
      })
      .finally(() => {
        setMtuLoading(false);
      });
  };

  const handleMtuDialogOpen = () => {
    setMtuDialogOpen(true);
    setMtuError("");
    fetchMtu();
  };

  const handleMtuDialogClose = () => {
    if (!mtuSubmitting) {
      setMtuDialogOpen(false);
      setMtuValue("");
      setMtuError("");
    }
  };

  const updateMtu = () => {
    const mtu = parseInt(mtuValue);
    if (isNaN(mtu) || mtu < 1 || mtu > 1500) {
      setMtuError("MTU value must be between 1 and 1500");
      return;
    }

    setMtuSubmitting(true);
    setMtuError("");
    axios
      .post(`/device/${device_uuid}/mtu`, { mtu })
      .then((response) => {
        setMessage("MTU updated successfully");
        setMtuDialogOpen(false);
        setMtuValue("");
        setMtuError("");
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.detail || error?.response?.data?.message || error?.message || "Failed to update MTU";
        setMtuError(errorMessage);
      })
      .finally(() => {
        setMtuSubmitting(false);
      });
  };

  const validateIPAddress = (address) => {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        address
      )
    ) {
      return true;
    }
    return false;
  };

  const handleLanIpDialogOpen = () => {
    setLanIpDialogOpen(true);
    setLanIpError("");
    setLanIpValue("");
    fetchLanIp();
  };

  const handleLanIpDialogClose = () => {
    if (!lanIpSubmitting) {
      setLanIpDialogOpen(false);
      setLanIpValue("");
      setLanIpError("");
    }
  };

  const setLanIp = () => {
    if (!lanIpValue || !validateIPAddress(lanIpValue)) {
      setLanIpError("Please enter a valid IP address");
      return;
    }

    setLanIpSubmitting(true);
    setLanIpError("");
    axios
      .put(`/device/${device_uuid}/set_lan_ip`, { ip_address: lanIpValue })
      .then((response) => {
        setMessage("LAN IP set successfully");
        setLanIpDialogOpen(false);
        setLanIpValue("");
        setLanIpError("");
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.detail || error?.response?.data?.message || error?.message || "Failed to set LAN IP";
        setLanIpError(errorMessage);
      })
      .finally(() => {
        setLanIpSubmitting(false);
      });
  };

  const fetchLanIp = () => {
    setLanIpLoading(true);
    setLanIpError("");
    axios
      .get(`/device/${device_uuid}/lan_ip`)
      .then((response) => {
        const currentLanIp = response?.data?.lan_ip;
        // If the device has no previously configured LAN IP, keep the field blank.
        setLanIpValue(
          typeof currentLanIp === "string" ? currentLanIp.trim() : ""
        );
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch LAN IP";
        setLanIpError(errorMessage);
      })
      .finally(() => {
        setLanIpLoading(false);
      });
  };

  const getSimActivityInfo = () => {
    axios
      .get(`/device/${device_uuid}/sim_activity?page=1&page_size=1`)
      .then((response) => {
        setSimActivity(
          response?.data?.total > 0 ? response.data.rlogs[0] : null
        );
      })
      .catch((error) => {
        setError(error?.response?.data?.detail);
      });
  };

  const getConnectedDevice = () => {
    setDeviceLoading(true);
    axios
      .get(`/device/${device_uuid}/connection_details`)
      .then((response) => {
        setConnectedDevices(response?.data?.connected_devices);
      })
      .catch((error) => {})
      .finally(() => {
        setDeviceLoading(false);
      });
  };

  const initiateNetScan = () => {
    setLoading(true);
    axios
      .get(`/device/${device_uuid}/start-net-scan`)
      .then((response) => {
        if (response.status === 200) {
          setMessage(response.data.message);
        }
      })
      .catch((error) => {
        setError(error.response.data.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setDefaultDeviceConfig = () => {
    setLoading(true);
    axios
      .post(`/device/${device_uuid}/default_config`)
      .then((response) => {
        setConfirmConfigDialog(null);
        if (response.data.success) {
          setMessage(response.data.message);
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        setError(error.response.data.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const activateM1Iccid = () => {
    setLoading(true);
    axios
      .post(`/device/${device_uuid}/activate_m1_iccid`)
      .then((response) => {
        if (response.data.success) {
          setMessage(response.data.message);
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        setError(error.response.data.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!deviceInfo) return;
    if (!deviceDBInfo) return;
    if (!deviceInfo?.serial.startsWith("MR4")) return;
    if (!deviceDBInfo?.device_ping_id && deviceInfo?.status === 1) {
      axios
        .post(`/device/${device_uuid}/update_device_ping_id`)
        .then((response) => {})
        .catch((error) => {});
    }
  }, [deviceInfo, deviceDBInfo]);

  // useEffect(() => {
  //   if (deviceInfo?.serial !== undefined && portInfo !== undefined) {
  //     console.log(deviceInfo?.serial);
  //     window.FreshworksWidget("identify", "ticketForm", {
  //       name: getName(),
  //       email: getEmail(),
  //     });

  //     window.FreshworksWidget("hide", "ticketForm", [
  //       "subject",
  //       "name",
  //       "email",
  //       "product_id",
  //       "custom_fields.cf_device_label",
  //       "custom_fields.cf_port_group",
  //       "custom_fields.cf_device_m1_status",
  //       "custom_fields.cf_used_data_mb",
  //       "custom_fields.cf_software_version",
  //       "custom_fields.cf_admin_link",
  //       "custom_fields.cf_hostnamepublic_ip",
  //       "custom_fields.cf_gps_coordinates",
  //       "custom_fields.cf_sim_m2_provider",
  //       "custom_fields.cf_band",
  //       "custom_fields.cf_sim_m2_status",
  //       "custom_fields.cf_signal_strength106409",
  //       "custom_fields.cf_tower_connection_info",
  //     ]);
  //     console.log(`Test : ${portInfo?.spt_band}`);

  //     window.FreshworksWidget("prefill", "ticketForm", {
  //       subject: `Issue with device ${deviceInfo.serial}`,
  //       custom_fields: {
  //         cf_device_serial_no: deviceInfo.serial, //Single line text field
  //         cf_device_label:
  //           deviceInfo?.label === null ? "NO LABEL" : deviceInfo?.label, //Single line text field
  //         cf_port_group: deviceInfo.portgroups, //Single line text field
  //         cf_device_m1_status:
  //           deviceInfo?.status_formatted === ""
  //             ? "NO STATUS"
  //             : deviceInfo?.status_formatted,
  //         cf_used_data_mb: deviceInfo?.useddata
  //           ? (deviceInfo.useddata / 1024).toFixed(2)
  //           : "",
  //         cf_software_version: deviceInfo?.app_version,
  //         cf_admin_link: deviceInfo?.admin_link,
  //         cf_hostnamepublic_ip: deviceInfo?.ip,
  //         cf_gps_coordinates: deviceInfo?.gps,
  //         cf_sim_m2_provider: portInfo?.sim_provider,
  //         cf_band: portInfo?.spt_band,
  //         cf_sim_m2_status:
  //           portInfo?.status_formatted === ""
  //             ? "NO STATUS"
  //             : portInfo?.status_formatted,
  //         cf_signal_strength106409: portInfo?.spt_signal,
  //         cf_tower_connection_info: `MCC - ${portInfo?.mcc} , MNC - ${portInfo?.mnc} , LAC - ${portInfo?.spt_lac} , Cell Id - ${portInfo?.spt_cellid}`,
  //       },
  //     });

  //     window.FreshworksWidget("disable", "ticketForm", [
  //       "custom_fields.cf_device_serial_no",
  //     ]);
  //   }
  // }, [deviceInfo, portInfo]);

  const refreshData = () => {
    getDeviceInfo();
    getM1Info();
    hasSimActivityAccess() && getSimActivityInfo();
    // getConnectedDevice();
  };

  // useEffect(() => {
  //   getDeviceInfo();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   return () => {
  //     window.FreshworksWidget("destroy");
  //   };
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    getDeviceInfo();
    getM1Info();
    hasSimActivityAccess() && getSimActivityInfo();
    getNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      window.FreshworksWidget("destroy");
    };
    // eslint-disable-next-line
  }, [device_uuid]);

  const handleChange = (event, newValue) => {
    if (newValue) {
      setTabValue(newValue);
    }
  };
  const showNetworking = () =>
    (isSuperAdmin() || hasNetworkingAccess()) && deviceInfo?.serial;

  // Ensure tabValue is always valid
  const validTabValues = ["Info", "MonthlyUsage"];
  if (!isSemsimBasicUser()) {
    validTabValues.push("SpeedTest", "NetScan", "NetDiag");
  }
  if (showNetworking() && deviceInfo) {
    validTabValues.push("Networking", "Configuration");
  }
  if ((isSuperAdmin() || hasUptimeAccess()) && deviceInfo?.serial) {
    validTabValues.push("Monitor");
  }

  const currentTabValue = validTabValues.includes(tabValue) ? tabValue : "Info";

  useEffect(() => {
    const newCoordinates = [];

    if (!portInfo) return;

    if (portInfo?.cell_latitude && portInfo?.cell_longitude) {
      newCoordinates.push({
        latitude: parseFloat(portInfo?.cell_latitude),
        longitude: parseFloat(portInfo?.cell_longitude),
        popupContent: `MCC - ${portInfo?.mcc} , MNC - ${portInfo?.mnc} , LAC - ${portInfo?.spt_lac} , Cell Id - ${portInfo?.spt_cellid}`,
        type: "tower",
      });
    }

    setCoordinates(newCoordinates);
  }, [portInfo]);

  const ConfirmDefaultDialog = (_) => {
    return (
      <Dialog
        open={confirmConfigDialog}
        onClose={() => setConfirmConfigDialog(null)}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Typography>
            Do you want to reset the device to default configuration?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disabled={loading}
            onClick={setDefaultDeviceConfig}
            color="primary"
          >
            Confirm
          </Button>
          <Button onClick={() => setConfirmConfigDialog(null)} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Layout
      containerMaxWidth="xl"
      loading={loading}
      error={error}
      successMessage={message}
    >
      {/* <Helmet>
        <script
          type="text/javascript"
          src="https://widget.freshworks.com/widgets/151000003887.js"
          async
          defer
        ></script>
        ;
      </Helmet> */}
      <ConfirmDefaultDialog />
      <Box pt={3}>
        <DeviceSearch
          value={searchValue}
          setValue={setSearchValue}
          handleSubmit={() => history.push(`/devices?q=${searchValue}`)}
          handleClear={() => setSearchValue()}
        />
      </Box>
      <Box pt={2} pb={2}>
        <Grid
          container
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item>
                <GoBackButton />
              </Grid>
              {deviceInfo && (
                <Grid item>
                  <Typography>{`Serial : ${deviceInfo?.serial}`}</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          {ssidModal && (
            <DeviceSsidModal
              handleClose={setSsidModal}
              device_uuid={device_uuid}
              open={ssidModal}
            />
          )}
          {!isSemsimBasicUser() && (
            <Grid item>
              <Grid container spacing={5}>
                <Grid item>
                  <SpeedTest
                    setLoading={setLoading}
                    name="Rapid"
                    speed_test_type={SPEED_TEST_TYPES.IPERF}
                  />
                </Grid>
                <Grid item>
                  <SpeedTest
                    setLoading={setLoading}
                    name="Normal"
                    speed_test_type={SPEED_TEST_TYPES.NORMAL}
                  />
                </Grid>
                <Grid item>
                  <Button
                    onClick={initiateNetScan}
                    color="primary"
                    variant="outlined"
                    startIcon={<PermScanWifiIcon />}
                  >
                    Start Net Scan
                  </Button>
                </Grid>
                <Grid item>
                  <StartNetDiag setLoading={setLoading} />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>

      <AppBar position="static">
        <Tabs
          value={currentTabValue}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="Device Info" value="Info" />
          {!isSemsimBasicUser() && (
            <Tab label="Speed Test History" value="SpeedTest" />
          )}
          {!isSemsimBasicUser() && (
            <Tab label="Net Scan History" value="NetScan" />
          )}
          {!isSemsimBasicUser() && (
            <Tab label="Net Diagnosis Result" value="NetDiag" />
          )}
          {showNetworking() && deviceInfo && (
            <Tab label="Networking" value="Networking" />
          )}
          {showNetworking() && deviceInfo && (
            <Tab label="Configuration" value="Configuration" />
          )}
          {(isSuperAdmin() || hasUptimeAccess()) && deviceInfo?.serial && (
            <Tab label="Monitor" value="Monitor" />
          )}
          <Tab label="Monthly Usage" value="MonthlyUsage" />
        </Tabs>
      </AppBar>
      <TabContext value={currentTabValue}>
        <TabPanel value="Info">
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <Box display="flex" justifyContent="flex-end">
                {!isSemsimBasicUser() &&
                  !loading &&
                  deviceInfo?.status_formatted === "Reachable" && (
                    <>
                      {(isSuperAdmin() || hasNetworkingAccess()) && (
                        <DeviceRestartScheduleModal
                          deviceUUID={device_uuid}
                          initialData={{
                            scheduled_restart_frequency:
                              deviceDBInfo?.scheduled_restart_frequency || null,
                            scheduled_restart_time:
                              deviceDBInfo?.scheduled_restart_time || null,
                            scheduled_restart_day:
                              deviceDBInfo?.scheduled_restart_day ?? null,
                          }}
                          setMessage={setMessage}
                          setError={setError}
                        />
                      )}
                      <RestartDevice
                        deviceUUID={device_uuid}
                        deviceData={deviceInfo}
                        setMessage={setMessage}
                        setError={setError}
                      />
                      {(isSuperAdmin() || hasUptimeAccess()) &&
                        deviceInfo?.serial && (
                          <UptimePingDevice
                            deviceUUID={device_uuid}
                            deviceData={deviceInfo}
                            setMessage={setMessage}
                            setError={setError}
                          />
                        )}
                    </>
                  )}
                {!isSemsimBasicUser() &&
                  portInfo?.status_formatted === "Registered" &&
                  checkDeviceInfo(deviceInfo) && (
                    <Button
                      onClick={() => setSsidModal(true)}
                      color="primary"
                      variant="contained"
                      startIcon={<PermScanWifiIcon />}
                      style={{ marginRight: "12px" }}
                    >
                      Update SSID
                    </Button>
                  )}
                {!isSemsimBasicUser() && checkDeviceInfo(deviceInfo) && (
                  <Tooltip
                    title={deviceInfo?.changes_pending ? "Changes pending" : ""}
                  >
                    <span>
                      <Button
                        onClick={() => setConfirmConfigDialog(true)}
                        color="primary"
                        variant="contained"
                        disabled={deviceInfo?.changes_pending}
                        startIcon={<Settings />}
                        style={{ marginRight: "12px" }}
                      >
                        Reset Device Config
                      </Button>
                    </span>
                  </Tooltip>
                )}
                {checkDeviceInfo(deviceInfo) &&
                  (isSuperAdmin() || hasNetworkingAccess()) && (
                    <Button
                      onClick={handleMtuDialogOpen}
                      color="primary"
                      variant="contained"
                      style={{ marginRight: "12px" }}
                    >
                      Update MTU
                    </Button>
                  )}
                {checkDeviceInfo(deviceInfo) &&
                  (isSuperAdmin() || hasNetworkingAccess()) && (
                    <Button
                      onClick={handleLanIpDialogOpen}
                      color="primary"
                      variant="contained"
                      style={{ marginRight: "12px" }}
                    >
                      Set LAN IP
                    </Button>
                  )}
                {!isSemsimBasicUser() && (
                  <DeviceActionHistory
                    device_id={device_uuid}
                    serial_no={deviceInfo?.serial}
                    setLoading={setLoading}
                    button={true}
                  />
                )}
                <RefreshButton refreshAction={refreshData} />
              </Box>
            </Grid>
            <Grid item>
              <TableContainer component={Paper}>
                <Table aria-label="profile table">
                  <TableBody>
                    <TableRow>
                      <TableHeadCell>Label</TableHeadCell>
                      <TableCell>
                        {deviceInfo && (
                          <AddLabel
                            serial_no={deviceInfo?.serial}
                            device_id={device_uuid}
                            label={deviceInfo?.label}
                            setLoading={setLoading}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Reseller</TableHeadCell>
                      {deviceDBInfo && deviceDBInfo?.reseller_name && (
                        <TableCell>
                          {/* Show parent (child), or parent, if not then only child */}
                          {deviceDBInfo?.parent_reseller_name &&
                          deviceDBInfo?.child_reseller_name &&
                          deviceDBInfo?.parent_reseller_name !==
                            deviceDBInfo?.child_reseller_name
                            ? `${deviceDBInfo?.parent_reseller_name} (${deviceDBInfo?.child_reseller_name})`
                            : deviceDBInfo?.parent_reseller_name ||
                              deviceDBInfo?.child_reseller_name}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Serial</TableHeadCell>
                      <TableCell>
                        <Grid container spacing={2}>
                          <Grid item>{deviceInfo?.serial}</Grid>
                          {deviceInfo?.device_type && (
                            <Grid item>
                              <Chip
                                color="primary"
                                size="small"
                                label={deviceInfo?.device_type}
                              ></Chip>
                            </Grid>
                          )}
                        </Grid>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableHeadCell>
                        Port Group (Preferred Carrier)
                      </TableHeadCell>
                      <TableCell>
                        <ChangePortGroup
                          port_group={deviceInfo?.portgroups}
                          device_uuid={device_uuid}
                          device_name={deviceInfo?.name}
                          setLoading={setLoading}
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableHeadCell>Used data (MB)</TableHeadCell>
                      <TableCell>
                        {deviceInfo?.useddata &&
                          (deviceInfo.useddata / 1024).toFixed(2)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Device Status</TableHeadCell>
                      <TableCell>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item>
                            <DeviceStatus
                              status={deviceInfo?.status}
                              status_formatted={deviceInfo?.status_formatted}
                            />
                          </Grid>
                          {deviceInfo?.sleeping === 1 && (
                            <Grid item>
                              <Tooltip title="Device is in sleep mode">
                                <NightsStayIcon color="primary" />
                              </Tooltip>
                            </Grid>
                          )}
                        </Grid>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Device Plan</TableHeadCell>
                      <TableCell>
                        {hasPlanChangeAccess() ? (
                          <ChangeDevicePlan
                            device_plan={deviceInfo?.deviceplan}
                            device_uuid={device_uuid}
                            device_name={deviceInfo?.name}
                            setLoading={setLoading}
                          />
                        ) : (
                          <Typography>{deviceInfo?.deviceplan}</Typography>
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Pass Status</TableHeadCell>
                      <TableCell>
                        <PassStatus
                          status={deviceInfo?.pass_status}
                          status_formatted={deviceInfo?.pass_status_formatted}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Sim Status</TableHeadCell>
                      <TableCell>
                        <Grid container spacing={2} direction="row">
                          <Grid item>
                            <PortStatus
                              status={portInfo?.status}
                              status_formatted={portInfo?.status_formatted}
                              setLoading={setLoading}
                              setMessage={setMessage}
                              setError={setError}
                            />
                          </Grid>
                          {portInfo?.is_manual_allocation && (
                            <Grid item>
                              <Chip
                                label={"Manual Allocation"}
                                size="small"
                                style={{
                                  fontWeight: 500,
                                  background: BLUE,
                                }}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Sim Provider</TableHeadCell>
                      <TableCell>{portInfo?.sim_provider}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableHeadCell>
                        Primary Band & Signal Strength
                      </TableHeadCell>
                      {/* if no pcc strength and not cell info then use spt_signal */}
                      {portInfo?.pcc_strength || cellInfo?.sci_signal ? (
                        <TableCell>
                          {portInfo?.pcc_band || "Band " + cellInfo?.sci_band}{" "}
                          &nbsp;&nbsp;&nbsp;{" "}
                          <SignalStrength
                            signal={
                              cellInfo?.sci_signal
                                ? `${cellInfo?.sci_signal * -1} (dBm)`
                                : portInfo?.pcc_strength
                            }
                            cellInfo={cellInfo}
                          />
                        </TableCell>
                      ) : (
                        <TableCell>
                          {portInfo?.spt_signal === 0 ? (
                            "N/A"
                          ) : (
                            <SignalStrength
                              signal={`${portInfo?.spt_signal * -1} (dBm)`}
                            />
                          )}
                        </TableCell>
                      )}
                    </TableRow>

                    <TableRow>
                      <TableHeadCell>
                        Secondary Band(s) & Signal Strength
                      </TableHeadCell>
                      <TableCell>
                        {portInfo?.scc_band_info &&
                          portInfo?.scc_band_info.map((band_info) => {
                            return (
                              <div>
                                {band_info.band} &nbsp;&nbsp;&nbsp;{" "}
                                <SignalStrength
                                  signal={
                                    cellInfo && band_info?.band.includes("5G")
                                      ? `${cellInfo.sci_endc_signal * -1} (dBm)`
                                      : band_info?.strength
                                  }
                                  cellInfo={cellInfo}
                                />
                              </div>
                            );
                          })}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableHeadCell>Tower Connection Info</TableHeadCell>
                      <TableCell>
                        <Grid container>
                          <Grid item>
                            {` MCC - ${portInfo?.mcc} , MNC - ${portInfo?.mnc} , LAC - ${portInfo?.spt_lac} , Cell Id - ${portInfo?.spt_cellid}`}
                            <div>
                              <Tooltip
                                title={`Carrier Agg Info (Updated: ${moment(
                                  cellInfo?.sci_time * 1000
                                )
                                  .local()
                                  .format("lll")})`}
                              >
                                <Typography variant="caption">
                                  {splitSignal(
                                    cellInfo?.sci_ca_info ||
                                      portInfo?.spt_ca_info
                                  ).map((signal) => (
                                    <div key={signal}>{signal}</div>
                                  ))}
                                </Typography>
                              </Tooltip>
                              {(cellInfo?.sci_ca_info ||
                                portInfo?.spt_ca_info) && (
                                <ServingCellHistory
                                  device_serial={deviceInfo?.serial}
                                  device_uuid={device_uuid}
                                  setLoading={setLoading}
                                  setMessage={setMessage}
                                  loading={loading}
                                />
                              )}
                            </div>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Antenna Signal Strength</TableHeadCell>
                      <TableCell>
                        <AntennaSignalStrength
                          deviceType={deviceInfo?.device_type}
                          cellInfo={cellInfo}
                        />
                      </TableCell>
                    </TableRow>
                    {hasSimActivityAccess() && (
                      <TableRow>
                        <TableHeadCell>M1 Last Activity</TableHeadCell>
                        <TableCell>
                          {simActivity?.startdate ? (
                            <>
                              {`${moment
                                .utc(new Date(simActivity?.startdate * 1000))
                                .local()
                                .format("lll")} (${
                                simActivityStatusMap[simActivity?.stopcause]
                              })`}
                              <SimActivityLog
                                device_serial={deviceInfo?.serial}
                                device_uuid={device_uuid}
                                setLoading={setLoading}
                                setMessage={setMessage}
                                loading={loading}
                              />
                            </>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableHeadCell>M2 Last Seen Active</TableHeadCell>
                      <TableCell>
                        {cellInfo?.sci_time
                          ? moment
                              .utc(new Date(cellInfo.sci_time * 1000))
                              .local()
                              .format("lll")
                          : null}
                      </TableCell>
                    </TableRow>
                    {deviceInfo && deviceInfo?.serial.startsWith("MR4") && (
                      <TableRow>
                        <TableHeadCell>Connected Devices</TableHeadCell>
                        <TableCell>
                          <>
                            <ConnectedDevices
                              device_serial={deviceInfo?.serial}
                              connectedDevices={connectedDevices}
                              getConnectedDevices={getConnectedDevice}
                              loading={deviceLoading}
                            />
                          </>
                        </TableCell>
                      </TableRow>
                    )}

                    <TableRow>
                      <TableHeadCell>Software Version</TableHeadCell>
                      <TableCell>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item>{deviceInfo?.app_version}</Grid>
                          <Grid item>
                            {deviceInfo?.is_fw_update_available &&
                              deviceInfo?.status === 1 && (
                                <UpdateDeviceFW
                                  deviceData={{
                                    ...deviceInfo,
                                    uuid: device_uuid,
                                  }}
                                  setMessage={setMessage}
                                  setError={setError}
                                />
                              )}
                            {deviceInfo &&
                              deviceInfo?.dev_package_updated_date && (
                                <Grid item>
                                  {deviceInfo?.dev_package_updated_date &&
                                  deviceInfo?.dev_package_updated_date !== "0"
                                    ? `Last Updated at: ${moment(
                                        deviceInfo.dev_package_updated_date *
                                          1000
                                      )
                                        .local()
                                        .format("lll")}`
                                    : "Last Updated at: -"}
                                </Grid>
                              )}
                          </Grid>
                          <Grid item>
                            {deviceInfo?.is_fw_update_in_progress && (
                              <Chip
                                label="Firmware Update in Progress"
                                color="primary"
                                size="small"
                              />
                            )}
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                    {deviceInfo && deviceInfo?.serial.startsWith("MR4") && (
                      <TableRow>
                        <TableHeadCell>Admin Link</TableHeadCell>
                        <TableCell>
                          <Link
                            href={deviceInfo?.admin_link}
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            {deviceInfo?.admin_link}
                          </Link>
                        </TableCell>
                      </TableRow>
                    )}

                    {!m1Loading && m1Info && Object.keys(m1Info).length > 0 && (
                      <TableRow>
                        <TableHeadCell>{`M1${
                          m1Info.iccid ? " ICCID & " : " "
                        }Status`}</TableHeadCell>
                        <TableCell>
                          <Grid container spacing={3}>
                            {m1Info.iccid && (
                              <Grid item>
                                <Typography>{m1Info.iccid}</Typography>
                              </Grid>
                            )}

                            {m1Info?.status && (
                              <Grid item>
                                <Chip
                                  label={m1Info.status}
                                  size="small"
                                  style={{
                                    fontWeight: 500,
                                    background:
                                      m1Info.status === "activated"
                                        ? GREEN
                                        : m1Info.status === "deactivated"
                                        ? RED
                                        : YELLOW,
                                    color: m1Info.status === "deactivated",
                                  }}
                                />
                              </Grid>
                            )}

                            {m1Info?.tags &&
                              m1Info?.tags.map((tag) => {
                                return (
                                  <Grid item>
                                    <Chip
                                      label={tag}
                                      size="small"
                                      style={{
                                        fontWeight: 500,
                                        background: BLUE,
                                      }}
                                    />
                                  </Grid>
                                );
                              })}
                            {m1Info?.roaming_profile && (
                              <Grid item>
                                <Tooltip title="Roaming Profile">
                                  <Chip
                                    label={m1Info.roaming_profile}
                                    size="small"
                                    color="primary"
                                  />
                                </Tooltip>
                              </Grid>
                            )}
                            {m1Info?.status &&
                              m1Info?.status !== "activated" &&
                              (!(
                                m1Info?.tags &&
                                m1Info?.tags.includes("imei_change")
                              ) ||
                                isSuperAdmin()) && (
                                <Grid item>
                                  <Button
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    onClick={activateM1Iccid}
                                  >
                                    Acitvate M1
                                  </Button>
                                </Grid>
                              )}
                          </Grid>
                        </TableCell>
                      </TableRow>
                    )}

                    {portInfo && portInfo?.sim_iccid && (
                      <TableRow>
                        <TableHeadCell>M2 Sim ICCID</TableHeadCell>
                        <TableCell>
                          <Grid container spacing={3}>
                            {portInfo?.sim_iccid && (
                              <Grid item>
                                <Typography>{portInfo?.sim_iccid}</Typography>
                              </Grid>
                            )}
                          </Grid>
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableHeadCell>Latest Speed Test Result</TableHeadCell>
                      <TableCell>
                        {latestSpeedTestResult &&
                          latestSpeedTestResult.download_speed && (
                            <Typography>
                              {`${latestSpeedTestResult.download_speed} down ${
                                latestSpeedTestResult.upload_speed
                              } up  ${latestSpeedTestResult.carrier} ${
                                latestSpeedTestResult.pcc_band
                              } Last Updated ${moment(
                                latestSpeedTestResult.str_time * 1000
                              )
                                .local()
                                .fromNow()}`}
                            </Typography>
                          )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>
                        Best Signal From Last Net Scan
                      </TableHeadCell>
                      <TableCell>
                        {latestNetScanResult &&
                          latestNetScanResult.best_result && (
                            <Typography>
                              {`${
                                latestNetScanResult?.best_result.operator_name
                              } 
                          ${latestNetScanResult?.best_result.rat} BAND  
                          ${latestNetScanResult?.best_result.band} 
                          ${latestNetScanResult?.best_result.signal} (dBm) 
                          Last Updated ${moment(
                            latestNetScanResult?.nsr_time * 1000
                          )
                            .local()
                            .fromNow()} `}
                            </Typography>
                          )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableHeadCell>Device Co-Ordinates</TableHeadCell>
                      <TableCell>
                        <Map coordinates={coordinates} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                mb={1}
                justifyContent="flex-start"
                sx={{ gap: "10px" }}
              >
                <Typography variant="h6" align="left">
                  Notes
                </Typography>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={() => setAddNoteOpen(true)}
                >
                  Add Note
                </Button>
              </Box>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="notes table">
                  <TableBody>
                    {notesLoading ? (
                      <TableRow>
                        <TableCell>
                          <Typography variant="body2">Loading notes...</Typography>
                        </TableCell>
                      </TableRow>
                    ) : notes?.length > 0 ? (
                      <>
                        <TableRow>
                          <TableHeadCell>Note</TableHeadCell>
                          <TableHeadCell>User</TableHeadCell>
                          <TableHeadCell>Timestamp</TableHeadCell>
                        </TableRow>
                        {notes.map((n) => (
                          <TableRow key={n.id}>
                            <TableCell style={{ width: "60%" }}>
                              {n?.notes}
                            </TableCell>
                            <TableCell style={{ width: "20%" }}>
                              {n?.user?.full_name || n?.user?.email || "-"}
                            </TableCell>
                            <TableCell style={{ width: "20%" }}>
                              {n?.created_at
                                ? moment(n.created_at).local().format("lll")
                                : n?.timestamp
                                ? moment(n.timestamp).local().format("lll")
                                : "-"}
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    ) : (
                      <TableRow>
                        <TableCell>
                          <Typography variant="body2">No notes yet.</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </TabPanel>
        {!isSemsimBasicUser() && (
          <TabPanel value="SpeedTest">
            <SpeedTestHistory
              setError={setError}
              setLoading={setLoading}
              loading={loading}
            />
          </TabPanel>
        )}
        {!isSemsimBasicUser() && (
          <TabPanel value="NetScan">
            <NetScanHistory
              setError={setError}
              setLoading={setLoading}
              loading={loading}
            />
          </TabPanel>
        )}
        {!isSemsimBasicUser() && (
          <TabPanel value="NetDiag">
            <NetDiagResult
              setError={setError}
              setLoading={setLoading}
              loading={loading}
            />
          </TabPanel>
        )}
        {(isSuperAdmin() || hasNetworkingAccess()) && deviceInfo?.serial && (
          <TabPanel value="Networking">
            <DeviceNetwork
              setError={setError}
              setMessage={setMessage}
              deviceSerial={deviceInfo.serial}
            />
          </TabPanel>
        )}
        {(isSuperAdmin() || hasNetworkingAccess()) && deviceInfo?.serial && (
          <TabPanel value="Configuration">
            <DeviceConfiguration
              setError={setError}
              setMessage={setMessage}
              deviceUuid={device_uuid}
            />
          </TabPanel>
        )}
        {(isSuperAdmin() || hasUptimeAccess()) && deviceInfo?.serial && (
          <TabPanel value="Monitor">
            <DeviceMonitor deviceUuid={device_uuid} />
          </TabPanel>
        )}
        {deviceInfo?.serial && (
          <TabPanel value="MonthlyUsage">
            <DeviceMonthlyUsageHistory
              setError={setError}
              setLoading={setLoading}
              loading={loading}
            />
          </TabPanel>
        )}
      </TabContext>

    <Dialog
      open={addNoteOpen}
      onClose={() => (!addNoteSubmitting ? setAddNoteOpen(false) : null)}
      aria-labelledby="add-note-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="add-note-title">Add Note</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          variant="outlined"
          label="Notes"
          placeholder="Write your note here"
          multiline
          rows={4}
          value={newNoteText}
          onChange={(e) => setNewNoteText(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setAddNoteOpen(false)} color="primary" disabled={addNoteSubmitting}>
          Cancel
        </Button>
        <Button
          onClick={createNote}
          color="primary"
          variant="contained"
          disabled={addNoteSubmitting || !newNoteText.trim()}
        >
          {addNoteSubmitting ? "Adding..." : "Add"}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={mtuDialogOpen}
      onClose={handleMtuDialogClose}
      aria-labelledby="mtu-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="mtu-dialog-title">Update MTU</DialogTitle>
      <DialogContent>
        {mtuError && (
          <Alert severity="error" style={{ marginBottom: "16px" }}>
            {mtuError}
          </Alert>
        )}
        {mtuLoading ? (
          <Box p={3}>
            <Typography>Loading current MTU value...</Typography>
          </Box>
        ) : (
          <>
            <Alert severity="warning" style={{ marginBottom: "16px" }}>
              Warning: If the MTU value is set incorrectly, your unit may become unstable.
            </Alert>
            <Box p={2}>
              <TextField
                autoFocus
                fullWidth
                variant="outlined"
                label="MTU Value"
                type="number"
                inputProps={{ min: 1, max: 1500 }}
                value={mtuValue}
                onChange={(e) => setMtuValue(e.target.value)}
                helperText="Enter a value between 1 and 1500"
                error={mtuValue && (isNaN(parseInt(mtuValue)) || parseInt(mtuValue) < 1 || parseInt(mtuValue) > 1500)}
              />
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={handleMtuDialogClose} 
          color="primary" 
          disabled={mtuSubmitting || mtuLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={updateMtu}
          color="primary"
          variant="contained"
          disabled={mtuSubmitting || mtuLoading || !mtuValue || isNaN(parseInt(mtuValue)) || parseInt(mtuValue) < 1 || parseInt(mtuValue) > 1500}
        >
          {mtuSubmitting ? "Updating..." : "Update"}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={lanIpDialogOpen}
      onClose={handleLanIpDialogClose}
      aria-labelledby="lan-ip-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="lan-ip-dialog-title">Set LAN IP</DialogTitle>
      <DialogContent>
        {lanIpError && (
          <Alert severity="error" style={{ marginBottom: "16px" }}>
            {lanIpError}
          </Alert>
        )}
        {lanIpLoading ? (
          <Box p={3}>
            <Typography>Loading current LAN IP value...</Typography>
          </Box>
        ) : (
          <>
            <Alert severity="warning" style={{ marginBottom: "16px" }}>
              Warning: Setting an incorrect LAN IP address may cause network connectivity issues.
            </Alert>
            <Box p={2}>
              <TextField
                autoFocus
                fullWidth
                variant="outlined"
                label="IP Address"
                value={lanIpValue}
                onChange={(e) => setLanIpValue(e.target.value)}
                helperText="Enter a valid IPv4 address (e.g., 192.168.1.1)"
                error={lanIpValue && !validateIPAddress(lanIpValue)}
              />
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={handleLanIpDialogClose} 
          color="primary" 
          disabled={lanIpSubmitting || lanIpLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={setLanIp}
          color="primary"
          variant="contained"
          disabled={
            lanIpSubmitting ||
            lanIpLoading ||
            !lanIpValue ||
            !validateIPAddress(lanIpValue)
          }
        >
          {lanIpSubmitting ? "Setting..." : "Set"}
        </Button>
      </DialogActions>
    </Dialog>

      {showSupportButton() && (
        <div>
          <div
            style={{
              ...styles.chatWidget,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                style={styles.chatWidgetBtn}
                startIcon={<HelpOutline />}
                onClick={() => setIsHelpFormOpen(true)}
              >
                Help
              </Button>
            </div>
          </div>
          {isHelpFormOpen && (
          <div style={styles.formContainer}>
            <Grid container direction="column" justifyContent="right">
              <Grid item>
                <Button
                  style={{
                    position: "fixed",
                    right: "20px",
                  }}
                  startIcon={<Close />}
                  onClick={() => setIsHelpFormOpen(false)}
                >
                  Close
                </Button>
              </Grid>
              <Grid item>
                <iframe
                  title="device-signal-help-form"
                  src={`https://share.hsforms.com/147xdoeuFSpWSz7KOB6pBYArg7tl?firstname=${getName()}&lastname=${getName()}&email=${getEmail()}&serial_number=${
                    deviceInfo?.serial
                  }&port_group=${deviceInfo?.portgroups}&used_data=${
                    deviceInfo?.useddata
                  }&subject=${`Device ID ${deviceInfo?.serial}`}&pass_status=${
                    deviceInfo?.pass_status_formatted
                  }&device_status=${
                    deviceInfo?.status_formatted
                  }&sim_provider=${portInfo?.sim_provider}&sim_status=${
                    portInfo?.status_formatted
                  }&software_version=${deviceInfo?.app_version}&signal=${
                    portInfo?.spt_signal
                  }`}
                  height="770px"
                  width="500px"
                ></iframe>
              </Grid>
            </Grid>
          </div>
          )}
        </div>
      )}

      {/* {formtest && (
        <>
          <Typography>
            {`https://share.hsforms.com/147xdoeuFSpWSz7KOB6pBYArg7tl?firstname=${getName()}&
            lastname=${getName()}
            &email=${getEmail()}
            &serial_number=${deviceInfo?.serial}&subject=${
              deviceInfo?.serial
            }&port_group=${deviceInfo?.portgroups}&used_data=${
              deviceInfo?.useddata
            }&pass_status=${deviceInfo?.pass_status_formatted}&device_status=${
              deviceInfo?.status_formatted
            }&sim_provider=${portInfo?.sim_provider}&sim_status=${
              portInfo?.status_formatted
            }&software_version=${deviceInfo?.app_version}&signal=${
              portInfo?.spt_signal
            }`}
          </Typography>
        </>
      )} */}
    </Layout>
  );
};

export default DeviceInfoSignal;
